import { Injectable } from '@angular/core';

export type CookieConsentValue = 'accepted' | 'rejected';

export interface CookieConsentState {
  version: string;
  updatedAtIso: string;
  analytics: CookieConsentValue;
}

const STORAGE_KEY = 'waitron_cookie_consent';
const POLICY_VERSION = '1.0.0';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  get policyVersion() {
    return POLICY_VERSION;
  }

  getState(): CookieConsentState | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as CookieConsentState;

      // If version changed, treat as not set (forces re-consent)
      if (!parsed?.version || parsed.version !== POLICY_VERSION) return null;

      return parsed;
    } catch {
      return null;
    }
  }

  setAnalyticsConsent(value: CookieConsentValue) {
    const state: CookieConsentState = {
      version: POLICY_VERSION,
      updatedAtIso: new Date().toISOString(),
      analytics: value,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  hasAnswered(): boolean {
    return !!this.getState();
  }

  analyticsAllowed(): boolean {
    return this.getState()?.analytics === 'accepted';
  }

  clearConsent() {
    localStorage.removeItem(STORAGE_KEY);
  }
}
